import React from "react";
import { useNavigate } from "react-router-dom";
// MUI
import { Grid2 } from "@mui/material";
// Icons
import { ReactComponent as WordpressSite } from "../../../../AdminAssets/svg/WordpressSite.svg";
import { ReactComponent as CloneSite } from "../../../../AdminAssets/svg/CloneSite.svg";
// styles
import styles from "./ReadyPage.module.scss";

export default function ReadyPage({ selectedOrg }) {
  const orgId = selectedOrg?.orgId ? selectedOrg?.orgId : -1;
  const navigate = useNavigate();

  return (
    <Grid2 className={styles.PageContainer}>
      <Grid2 className={styles.pageBox}>
        <Grid2
          className={styles.lastpage}
          onClick={() => window.location.reload()}
        >
          <WordpressSite className={styles.icon} />
          <Grid2 className={styles.edit}>Create another website</Grid2>
          <Grid2 className={styles.wordPressDis}>
            <Grid2 className={styles.panel}>Create Site</Grid2>
          </Grid2>
        </Grid2>
        <Grid2
          className={styles.lastpage}
          onClick={() => navigate(`/account/${orgId}/sites-overview`)}
        >
          <CloneSite className={styles.icon} />
          <Grid2 className={styles.edit}>Go to Rocon Control Panel</Grid2>
          <Grid2 className={styles.panel1}>Manage Sites</Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
}
